import React from 'react';

import { WarningOutlined } from '@ant-design/icons';
import { Flex, Modal } from 'antd';

export const ConfirmReturnToSenderModal = ({
  confirmRTSModalOpen,
  setConfirmRTSModalOpen,
  handleClickUpdateStatusRTS,
}: {
  confirmRTSModalOpen: boolean;
  setConfirmRTSModalOpen: (open: boolean) => void;
  handleClickUpdateStatusRTS: () => void;
}) => (
  <Modal
    title={
      <Flex gap="small">
        <WarningOutlined style={{ color: '#C82F21' }} />
        Return to Sender
      </Flex>
    }
    centered
    open={confirmRTSModalOpen}
    onOk={() => {
      handleClickUpdateStatusRTS();
      setConfirmRTSModalOpen(false);
    }}
    onCancel={() => setConfirmRTSModalOpen(false)}
    okText="Confirm Return to sender"
  >
    <p>
      This will mark the shipment as undelivrable and initiate the return
      process. The status can be reversed later if needed.
    </p>
    <br />
    <p>Are you sure you want to proceed?</p>
  </Modal>
);
